// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/design-system/components/feedback/Skeleton.jsx

import React from "react";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function Skeleton({
  width = "100%",
  height = "1rem",
  radius = "var(--oasys-radius-compact)",
  className = "",
  label = "Loading",
}) {
  return (
    <span
      className={joinClassNames("oasys-skeleton", className)}
      style={{ width, height, borderRadius: radius }}
      role="status"
      aria-label={label}
    />
  );
}
